export const ARTIFACT_NAME = 'people-and-teams-configuration-service';
export const FD_ENVIRONMENT = 'prod';
export const FD_CLIENT_FETCH_PROPS = {
  name: ARTIFACT_NAME,
  dimensions: {
    environmentType: FD_ENVIRONMENT
  }
};